<i class="material-icons">
  <ng-content></ng-content>
</i>
